import { api } from './axios'
import type {
  AssignQpaSeedsDto,
  QpaAssignmentResponseDto,
  QuotaSummaryDto,
  RevokeQpaSeedsDto,
  TenantQuotaSummaryDto,
} from './types'

// Get user quota summary
export const getUserQuotaSummary = async (): Promise<QuotaSummaryDto> => {
  const response = await api.get('/quota/summary')

  return response.data
}

// Get tenant quota summary for tenant admin
export const getTenantQuotaSummary = async (): Promise<TenantQuotaSummaryDto> => {
  const response = await api.get('/quota/tenant-summary')

  return response.data
}

// Assign QPA seeds to a user (TENANT_ADMIN only)
export const assignQpaSeeds = async (dto: AssignQpaSeedsDto): Promise<QpaAssignmentResponseDto> => {
  const response = await api.post('/quota/qpa/assign', dto)

  return response.data
}

// Revoke QPA seeds from a user (TENANT_ADMIN only)
export const revokeQpaSeeds = async (dto: RevokeQpaSeedsDto): Promise<QpaAssignmentResponseDto> => {
  const response = await api.post('/quota/qpa/revoke', dto)

  return response.data
}
